export enum switchappPaymentChannel {
  switchAppVirtualBankTransfer = "bank_transfer",
  card = "card",
  gateway = "gateway",
}
